// Create a full-screen mobile-only overlay component called MobileAuthComingSoon.
// Props: open (boolean), onClose (function), mode ("login" | "signup").
// When open === true, show a premium DocuHounds-style screen instead of the real auth flow.

import React, { useEffect } from "react";
import "./MobileAuthComingSoon.css";

export default function MobileAuthComingSoon({ open, onClose, mode = "login" }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const title = mode === "signup" ? "Scout is almost ready for you" : "Mobile login coming soon";
  const subtitle =
    mode === "signup"
      ? "We're putting the finishing touches on the DocuHounds mobile app. Scout's fetching something special for early students."
      : "For now, use DocuHounds in your mobile browser or on desktop while Scout finishes the native app.";

  return (
    <div className="dh-mobile-coming-overlay" onClick={onClose}>
      <div
        className="dh-mobile-coming-shell"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dh-mobile-coming-orbit"></div>

        <div className="dh-mobile-coming-card">
          <div className="dh-mobile-scout-badge">
            <div className="dh-mobile-scout-glow"></div>
            {/* Update image path to your existing Scout asset */}
            <img
              src="/landing_page_hero/scout_grad.png"
              alt="Scout the DocuHounds mascot"
            />
          </div>

          <h2 className="dh-mobile-coming-title">{title}</h2>
          <p className="dh-mobile-coming-subtitle">{subtitle}</p>

          <div className="dh-mobile-coming-pill">
            <span className="dh-mobile-pill-label">
              Built by students. Powered by AI.
            </span>
          </div>

          <button
            className="dh-mobile-coming-primary"
            type="button"
            onClick={onClose}
          >
            Back to Scout's homepage
          </button>

          <button
            className="dh-mobile-coming-secondary"
            type="button"
            onClick={onClose}
          >
            Continue in browser
          </button>
        </div>
      </div>
    </div>
  );
}
